// extracted by mini-css-extract-plugin
export default {"map-wrap":"MapElement_map-wrap__QblRe","gvnspBackground":"MapElement_gvnspBackground__GTh5Q","active":"MapElement_active__W-ZGD","dragHandler":"MapElement_dragHandler__jHgW6"};